import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

// Middleware, like Redux Thunk
const sagaMiddleware = createSagaMiddleware();
const middleware = [thunkMiddleware, sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger');
    const logger = createLogger({
        collapsed: true,
        predicate: (getState, action) => action.type && !action.type.startsWith('@'), // skip internal actions
    });

    middleware.push(logger);
}

const store = createStore(rootReducer, applyMiddleware(...middleware));
const history = syncHistoryWithStore(hashHistory, store);

store.runSaga = sagaMiddleware.run;
store.runSaga(rootSaga);

export default {
    store,
    history,
};
